<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! childHover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses(classes('containerClasses'), classes('customClasses'))">
      <draggable
        class="wf-flex wf-flex-wrap"
        :class="elementClasses(classes('tabsClasses'))"
        :style="elementStyles(styles('tabsStyles'))"
        v-model="sections"
        group="tabs"
        handle=".tab-handle"
      >
        <div
          v-for="section in sections"
          :class="selectedSection == section.id ? elementClasses(classes('activeClasses')) : elementClasses(classes('inactiveClasses'))"
          class="wf-px-5 wf-flex"
          :style="selectedSection == section.id ? elementStyles(styles('activeStyles')) : elementStyles(styles('inactiveStyles'))"
          :id="section.id"
          :key="section.id"
        >
          <button
            v-show="sections.length > 1 && ! previewMode"
            @click.prevent="deleteSection(section)"
            class="wf-text-xs focus:wf-outline-none wf-text-gray-500 hover:wf-text-red-500 focus:wf-text-blue-500"
          ><i class="fas fa-trash"></i></button>
          <button
            v-show="sections.length > 1 && ! previewMode"
            class="wf-text-xs tab-handle focus:wf-outline-none wf-text-gray-500 hover:wf-text-blue-500 wf-mx-2 focus:wf-text-blue-500"
          ><i class="fas fa-arrows-alt"></i></button>
          <div
            @click.prevent="selectedSection = section.id"
            class="focus:wf-outline-none wf-flex wf-items-center"
            :contenteditable="! previewMode"
            v-text="section.content.title"
            @input="updateSectionTitle($event.target.textContent, section)"
          ></div>
        </div>
        <div class="wf-flex wf-items-center wf-justify-center">
          <button
            v-show="! previewMode"
            class="wf-rounded wf-bg-gray-200 hover:wf-bg-gray-300 focus:wf-outline-none wf-h-8 wf-w-8 wf-flex wf-items-center wf-justify-center hover:wf-text-blue-500 wf-text-gray-500"
            @click.prevent="addTab()"
          ><i class="fas fa-plus wf-text-xs"></i></button>
        </div>
      </draggable>
      <div :class="elementClasses(classes('contentClasses'))" :style="elementStyles(styles('contentStyles'))">
        <EditorComponentSection :key="selectedSection" :parentModule="parentModule"/>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import draggable from 'vuedraggable'
  import { TabFactory } from '../factories/TabFactory'
  import EditorComponentSection from './EditorComponentSection'
  import EditorComponent from '../contracts/EditorComponent'
  import ListensPropertyEvents from '../mixins/ListensPropertyEvents'
  export default EditorComponent.extend({
    components: { draggable, EditorComponentSection },
    mixins: [ListensPropertyEvents],
    data() {
      return {
        selectedSection: null,
      }
    },
    created() {
      this.selectedSection = this.sections[0].id
    },
    computed: {
      sectionElement() {
        return {...this.element, componentSection: this.selectedSectionIndex}
      },
      editorContentClasses() {
        let editorClasses = ['wf-relative', 'wf-border', 'wf-border-transparent']
        if (this.childHover) {
          editorClasses.push('wf-border-blue-300')
        }
        return  editorClasses
      },
      selectedSectionIndex() {
          return this.sections.findIndex((tab) => tab.id == this.selectedSection)
      },
      sections: {
        get() {
          return this.$store.getters['componentSectionModule/elements'](this.element, this.parentModule)
        },
        set(value) {
          this.$store.dispatch('componentSectionModule/updateOrder', {
            ...this.element,
            value,
            parentModule: this.parentModule
          })
        },
      },
    },
    methods: {
      updateSectionTitle: _.debounce(function (newText, updatableSection) {
        let sectionIndex = this.sections.findIndex(section => section.id == updatableSection.id)
        this.addToObject('componentSectionModule', {title: newText}, 'content', null, {...this.element, componentSection: sectionIndex}, true, this.parentModule)
      }, 1000),
      deleteSection(deletableSection) {
        let tabId = this.sections.find(section => section.id == deletableSection.id).id
        if(tabId == this.selectedSection) {
          let newTabId = this.sections.find(section => section.id != deletableSection.id).id
          this.selectedSection = newTabId
        }
        this.removeFromArray(this.module, [deletableSection], 'sections', null, {}, true, this.parentModule)
      },
      addTab(qty = 1) {
        let tabs = (new TabFactory(qty)).create()
        this.addToArray(this.module, tabs, 'sections', null, {}, true, this.parentModule)
      },
    }
  })
</script>